'use strict';
(function () {
    App.controller('LifeListCtrl', lifeListCtrl);

    lifeListCtrl.$inject = ['$scope', 'lifeInsuranceService', '$state', '$filter'];

    function lifeListCtrl($scope, lifeInsuranceService, $state, $filter) {
        $scope.page = 'insurance';
        $scope.$emit('page', $scope.page);

        $scope.step = 'Moja deklaracja';
        $scope.$emit('step', $scope.step);

        $scope.link = 'root.life.data';
        $scope.$emit('link', $scope.link);

        $scope.filter = 'ALL';

        // Determine if user is logged in;
        if (window.sessionStorage.getItem('userObject')) {
            $scope.userObject = angular.fromJson(window.sessionStorage.getItem('userObject'));
            let branch = $scope.userObject.branch;
            if (branch && ((branch.company.id === 7 && branch.name === 'Cargo') || (branch.company.id === 7 && branch.name === 'CargoTabor'))) {
                $scope.showPopUp('', '', 'Aby przystąpić do programu grupowego ubezpieczenia na życie musisz uzupełnić oddział spółki oraz numer kadrowy w swoim Koncie Użytkownika.');
                $state.go('root.home.profile');
            }
        } else {

        }

        $scope.addDeclaration = function () {
            $state.go('root.life.edit', { declarations: $scope.declarations, person: null});
        };

        function groupByPersonType(list) {
            return $filter('groupBy')(list, 'type');
        }

        $scope.personTypesList = [
            {type: 'USER', name: 'Pracownik', limit: 3},
            {type: 'SPOUSE', name: 'Małżonek', limit: 3},
            {type: 'PARTNER', name: 'Partner', limit: 3},
            {type: 'CHILD', name: 'Dziecko', limit: 3},
        ];

        $scope.showMore = function(person) {
            person.limit += 3;
        };

        // Declarations;
        $scope.declarations = {};
        (function () {
            lifeInsuranceService.getGroupedDeclarations("ALL")
                .then(function (success) {
                    $scope.originalDeclarations = groupByPersonType(success.data.list);
                    $scope.declarations = filterByStatus($scope.originalDeclarations, $scope.filter);
                    $scope.emptyDeclarations = !(Object.keys($scope.declarations)).length;
                }, function (error) {
                    // @TODO: Determine what to do here on error;
                    console.error(error);
                });
        })();

        // Determine date;
        (function () {
            var date = new Date(),
                dayOfMonth = date.getDate(),
                month = date.getMonth() + 1,
                year = date.getFullYear(),
                requiredDayOfMonth = 15,
                formattedDate;

            if (month === 5 && year === 2018) requiredDayOfMonth = 27;

            if (dayOfMonth <= requiredDayOfMonth) {
                date = new Date(date.getFullYear(), date.getMonth() + 1);
                formattedDate = moment(date).format('YYYY-MM-DD');
                $scope.proposedDate = formattedDate;
            } else {
                date = new Date(date.getFullYear(), date.getMonth() + 2);
                formattedDate = moment(date).format('YYYY-MM-DD');
                $scope.proposedDate = formattedDate;
            }
        })();

        function filterByStatus(declarations, status) {
            return $filter('filterDeclarationsByStatus')(declarations, status);
        }

        $scope.$watch('filter', function () {
            $scope.declarations = filterByStatus($scope.originalDeclarations, $scope.filter);
        }, true);
    }
})();
